// extracted by mini-css-extract-plugin
export default {"root":"XCSs28u9","table":"n4sUZ0Sl","alignCenter":"NG5n7pmW","alignRight":"Anj7h33Z"};